// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3ppji","legacyBtn":"MutateMid_legacyBtn__1ml3T"};